<template>
    <div class="drawer-main">
        <div ref="drawer1">
            <v-navigation-drawer
                v-if="$auth.loggedIn && showDrawer1Sec"
                v-model="drawer"
                light
                app
                right
                temporary
                color="black"
                style="transition: 0.3s"
            >
                <!-- <v-navigation-drawer
v-model="drawer"
light
app
right
:temporary="!$breakpoint.smAndUp"
:permanent="$breakpoint.smAndUp"
>-->
                <div class="pb-10 left_border">
                    <!-- <v-list-item v-if="$auth.loggedIn" :class="getClassForCategory()">
<v-list-item-content>
  <v-list-item-title class="white--text text-center"
    >Hi, {{ name }}</v-list-item-title
  >
</v-list-item-content>
<v-btn
  fab
  x-small
  absolute
  outlined
  border-none
  style="border: none; color: white; right: 4px"
  @click="drawer = !drawer"
>
  <v-icon>mdi-close</v-icon>
</v-btn>
</v-list-item> -->
                    <profile-card title-size="f14"></profile-card>
                    <drawer-wallet
                        v-if="
                            userBalanceData &&
                            (userBalanceData.sbbonusid ||
                                userBalanceData.bonusid) &&
                            ((configurationData &&
                                configurationData.isSportBonusWalletOn) ||
                                (configurationData &&
                                    configurationData.isBonusWalletOn))
                        "
                    ></drawer-wallet>
                    <user-balance v-else></user-balance>
                    <!-- <v-divider
                        color="grey"
                        class="mt-3 mb-2 divider-color"
                    ></v-divider> -->
                    <v-col
                        v-if="
                            configurationData &&
                            configurationData.isNormalBonusWalletOn
                        "
                        class="d-flex justify-space-around pa-2 py-2"
                    >
                        <v-btn
                            to="/pending-bonus"
                            :loading="loading"
                            class="pa-4 f12 awaiting_bonus"
                        >
                            <span class="font-weight-bold white--text"
                                >{{ $t("Awaiting Bonus") }}
                            </span>
                            <span class="f12 primary--text">
                                {{ userPendingBonusSum | currencyFormat(0) }}
                            </span>
                        </v-btn>
                    </v-col>
                    <v-col
                        v-if="depositWhatsappLink"
                        class="d-flex justify-space-around pa-2"
                    >
                        <v-btn
                            :href="depositWhatsappLink"
                            :target="'_blank'"
                            color="primary"
                            :loading="loading"
                            class="pa-4 mr-1 f12 deposit_btn"
                        >
                            Deposit
                        </v-btn>
                        <v-btn
                            :href="depositWhatsappLink"
                            :target="'_blank'"
                            color="primary"
                            :loading="loading"
                            class="pa-3 f12 deposit_btn"
                            >Withdraw Now
                        </v-btn>
                    </v-col>
                    <v-col
                        v-else-if="
                            version &&
                            version.projectCode &&
                            version.projectCode !== 'fps'
                        "
                        class="d-flex justify-space-around pa-2"
                    >
                        <v-btn
                            :to="
                                getWhatsappData &&
                                getWhatsappData.isDepositBtnOn
                                    ? '/wallet/deposit'
                                    : ''
                            "
                            :href="
                                getWhatsappData &&
                                !getWhatsappData.isDepositBtnOn
                                    ? goToWhatsapp()
                                    : ''
                            "
                            :target="
                                getWhatsappData &&
                                !getWhatsappData.isDepositBtnOn
                                    ? '_blank'
                                    : ''
                            "
                            color="primary"
                            :loading="loading"
                            class="pa-4 mr-1 f12 deposit_btn"
                        >
                            Deposit
                        </v-btn>
                        <v-btn
                            v-if="
                                version &&
                                version.projectCode &&
                                version.projectCode !== 'fps'
                            "
                            :to="
                                getWhatsappData &&
                                getWhatsappData.isWithdrawBtnOn
                                    ? '/wallet/withdrawal'
                                    : ''
                            "
                            :href="
                                getWhatsappData &&
                                !getWhatsappData.isWithdrawBtnOn
                                    ? goToWhatsapp()
                                    : ''
                            "
                            :target="
                                getWhatsappData &&
                                !getWhatsappData.isWithdrawBtnOn
                                    ? '_blank'
                                    : ''
                            "
                            color="primary"
                            :loading="loading"
                            class="pa-3 f12 deposit_btn"
                            >Withdraw Now
                        </v-btn>
                    </v-col>

                    <v-col class="d-flex justify-space-around pa-2 py-2">
                        <v-btn
                            to="/referral"
                            color="primary"
                            :loading="loading"
                            class="pa-4 f12 deposit_btn referal_btn"
                        >
                            REFER AND EARN
                        </v-btn>
                    </v-col>
                    <v-divider
                        v-if="
                            version &&
                            version.projectCode &&
                            version.projectCode !== 'fps'
                        "
                        color="grey"
                        class="mt-4 divider-color"
                    ></v-divider>
                    <v-list
                        dense
                        class="right_drawer py-0"
                        :class="
                            version &&
                            version.projectCode &&
                            version.projectCode !== 'fps'
                                ? ''
                                : 'mt-4'
                        "
                    >
                        <v-col
                            v-for="item in items"
                            v-show="
                                !item.environment ||
                                (item.environment &&
                                    item.environment === environment &&
                                    !item.disable) ||
                                (item.disable &&
                                    item.disable !== version.projectCode)
                            "
                            :key="item.title"
                            cols="12"
                            class="px-0 py-0"
                        >
                            <v-list-item
                                class="py-1 px-4"
                                :to="item.fpsLink ? '' : item.link"
                                target="blank"
                                color="primary"
                                :class="
                                    version &&
                                    version.projectCode &&
                                    version.projectCode !== 'fps'
                                        ? 'list_border'
                                        : 'list_border_top'
                                "
                            >
                                {{ item.active }}
                                <v-list-item-icon class="mr-4 pt-1">
                                    <!-- <v-icon
                                    :color="
                                        item.icon === 'mdi-account-group'
                                            ? 'white'
                                            : 'primary'
                                    "
                                    :src="`${CDN_IMG_URL}/right-drawer/${item.icon}.webp`"
                                    >{{ item.icon }}</v-icon
                                > -->
                                    <img
                                        :lazy-src="`${CDN_IMG_URL}/right-drawer/${item.icon}.webp`"
                                        :src="`${CDN_IMG_URL}/right-drawer/${item.icon}.webp`"
                                        :alt="item.title"
                                        class="not-white-drawer"
                                        width="20"
                                        height="20"
                                    />
                                    <img
                                        :lazy-src="`${CDN_IMG_URL}/right-drawer/${item.whiteImage}.webp`"
                                        :src="`${CDN_IMG_URL}/right-drawer/${item.whiteImage}.webp`"
                                        :alt="item.title"
                                        class="white-drawer"
                                        width="20"
                                        height="20"
                                    />
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title
                                        class="white--text font-weight-bold f14"
                                    >
                                        {{ $t(item.title) }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action
                                    v-if="item.title === 'Open Bets'"
                                >
                                    <span class="count-badge">{{
                                        totalNoCount +
                                        totalNoCountPremium +
                                        totalNoCountPremiumBookmaker
                                    }}</span>
                                </v-list-item-action>
                            </v-list-item>
                        </v-col>
                        <div
                            v-if="
                                version &&
                                version.projectCode &&
                                version.projectCode !== 'fps'
                            "
                        >
                            <v-col cols="12" class="px-0 py-0">
                                <v-list-item
                                    color="primary"
                                    class="py-1 px-4"
                                    @click="openFeedback"
                                >
                                    <v-list-item-icon class="mr-4 pt-1">
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/right-drawer/feedback.webp`"
                                            :src="`${CDN_IMG_URL}/right-drawer/feedback.webp`"
                                            alt="Feedback"
                                            class="not-white-drawer"
                                            width="20"
                                            height="20"
                                        />
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/right-drawer/feedback-white.webp`"
                                            :src="`${CDN_IMG_URL}/right-drawer/feedback-white.webp`"
                                            alt="Feedback"
                                            width="20"
                                            height="20"
                                            class="white-drawer"
                                        />
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="white--text f14 font-weight-bold"
                                            >Feedback</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </div>

                        <!-- <div
                            v-if="
                                version &&
                                version.projectCode &&
                                version.projectCode !== 'fps'
                            "
                        >
                            <v-divider
                                color="grey"
                                class="divider-color"
                            ></v-divider>
                            <v-col cols="12" class="px-0 py-0">
                                <v-list-item
                                    color="primary"
                                    class="py-1 px-4"
                                    @click="openChat()"
                                >
                                    <v-list-item-icon class="mr-4 pt-1">
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/right-drawer/chat_with_us.webp`"
                                            :src="`${CDN_IMG_URL}/right-drawer/chat_with_us.webp`"
                                            alt="Chat With Us"
                                            class="not-white-drawer"
                                            width="20"
                                            height="20"
                                        />
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/right-drawer/chat_with_us-white.webp`"
                                            :src="`${CDN_IMG_URL}/right-drawer/chat_with_us-white.webp`"
                                            alt="Chat With Us"
                                            contain
                                            width="20"
                                            height="20"
                                            class="white-drawer"
                                        />
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="white--text f14 font-weight-bold"
                                            >Chat With Us</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </div> -->
                        <div
                            v-if="
                                version &&
                                version.projectCode &&
                                version.projectCode !== 'fps' &&
                                callAvailableNow &&
                                getUserCategory &&
                                getUserCategory.categoryName &&
                                (getUserCategory.categoryName === 'Gold' ||
                                    getUserCategory.categoryName === 'Platinum')
                            "
                        >
                            <v-divider
                                color="grey"
                                class="divider-color"
                            ></v-divider>
                            <v-col cols="12" class="px-0 py-0">
                                <v-list-item
                                    class="py-1 px-4"
                                    @click="onRequestcall()"
                                >
                                    <v-list-item-icon class="mr-4 pt-1">
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/right-drawer/callback.webp`"
                                            :src="`${CDN_IMG_URL}/right-drawer/callback.webp`"
                                            alt="Request a Callback"
                                            class="not-white-drawer"
                                            width="20"
                                            height="20"
                                        />
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/right-drawer/callback-white.webp`"
                                            :src="`${CDN_IMG_URL}/right-drawer/callback-white.webp`"
                                            alt="Request a Callback"
                                            contain
                                            width="20"
                                            height="20"
                                            class="white-drawer"
                                        />
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="white--text f14 font-weight-bold"
                                            >Request a
                                            Callback</v-list-item-title
                                        >
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </div>
                    </v-list>
                    <!-- DAEK THEME TOGGLE SECTION-->
                    <!-- <v-list dense>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title
                        >Dark Theme</v-list-item-title
                    >
                </v-list-item-content>
                <v-list-item-action>
                    <v-switch
                        v-model="$vuetify.theme.dark"
                        hide-details
                    ></v-switch>
                </v-list-item-action>
            </v-list-item>
        </v-list> -->
                    <!-- WHATSAPP SECTION IN DRAWER -->
                    <v-list-item
                        v-if="
                            (getWhatsappData &&
                                getWhatsappData.isWhatsAppNo &&
                                getWhatsappData.number &&
                                getWhatsappData.whatsAppLink &&
                                isAffiliateUser) ||
                            (getWhatsappData &&
                                getWhatsappData.isTelegramOn &&
                                getWhatsappData.telegramLink &&
                                isAffiliateUser)
                        "
                        class="grey darken-3 pt-0"
                    >
                        <v-list-item-content>
                            <v-list-item-title
                                class="text-center font-weight-bold white--text"
                            >
                                Connect with us on
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-col
                        v-if="
                            getWhatsappData &&
                            getWhatsappData.isWhatsAppNo &&
                            getWhatsappData.number &&
                            getWhatsappData.whatsAppLink &&
                            isAffiliateUser
                        "
                        class="px-2 py-0 pb-6 grey darken-3 whatsapp-style"
                        @click="goToWhatsappNew()"
                    >
                        <v-btn
                            :loading="loading"
                            class="pa-4 f12 referal_btn whatsapp-text grey darken-3"
                        >
                            <v-img
                                :lazy-src="`${CDN_IMG_URL}/right-drawer/register-whatsapp.webp`"
                                :src="`${CDN_IMG_URL}/right-drawer/register-whatsapp.webp`"
                                alt="Whatsapp Now"
                                contain
                                width="23"
                                max-width="23"
                                height="23"
                                class="mr-2"
                            ></v-img>
                            <span class="white--text font-weight-bold">
                                Whatsapp
                            </span>
                        </v-btn>
                    </v-col>
                    <v-col
                        v-if="
                            getWhatsappData &&
                            getWhatsappData.isTelegramOn &&
                            getWhatsappData.telegramLink &&
                            isAffiliateUser
                        "
                        class="px-2 py-0 pb-6 grey darken-3 whatsapp-style"
                        @click="goToTelgram()"
                    >
                        <v-btn
                            :loading="loading"
                            class="pa-4 f12 referal_btn telegram-text grey darken-3"
                        >
                            <v-img
                                :lazy-src="`${CDN_IMG_URL}/Telegram.webp`"
                                :src="`${CDN_IMG_URL}/Telegram.webp`"
                                alt="Telegram Now"
                                contain
                                width="23"
                                max-width="23"
                                height="23"
                                class="mr-2"
                            ></v-img>
                            <span class="white--text font-weight-bold">
                                Telegram
                            </span>
                        </v-btn>
                    </v-col>
                    <!-- LOGOUT BUTTON -->
                    <div class="pb-10 padding-bottom">
                        <v-btn
                            class="br-0 white--text"
                            color="green_bg"
                            block
                            @click="
                                drawer = false
                                $store.dispatch('user/logout')
                            "
                            >Logout</v-btn
                        >
                    </div>
                </div>
            </v-navigation-drawer>
        </div>
        <div ref="drawer2">
            <v-navigation-drawer
                v-if="showDrawer2Sec"
                v-model="drawer1"
                :color="$vuetify.theme.dark ? 'black' : 'grey lighten-2'"
                light
                app
                left
                temporary
                width="250"
                class=""
            >
                <v-card
                    flat
                    class="br-0 bg-image-css"
                    :img="
                        $auth.loggedIn
                            ? getCategoryWiseBackgroundImage()
                            : 'grey darken-4'
                    "
                    :class="[!$auth.loggedIn ? 'h150' : 'h100']"
                >
                    <profile-header
                        class="pa-4 pt-5 leftprofile"
                        title-size="f16"
                        membership-size="body-1"
                        color
                    >
                        <template #overlay>
                            <v-overlay v-if="!$auth.loggedIn" absolute>
                                <div>
                                    <v-img
                                        :src="`${CDN_IMG_URL}/website-logo.webp`"
                                        :lazy-src="`${CDN_IMG_URL}/website-logo.webp`"
                                        width="130"
                                        contain
                                        alt="Logo"
                                    >
                                    </v-img>
                                </div>

                                <div>
                                    <!-- <Button
        large
        btntitle="login / sign up"
        btn-link="/login"
      ></Button> -->
                                    <v-btn
                                        v-if="
                                            !$auth.loggedIn &&
                                            version &&
                                            version.projectCode &&
                                            (version.projectCode === 'gb' ||
                                                version.projectCode ===
                                                    'bd-new') &&
                                            getWhatsappData &&
                                            getWhatsappData.isRegisterBtnOnOff
                                        "
                                        :to="
                                            getWhatsappData.linkPage
                                                ? getWhatsappData.registerBtnLink
                                                : ''
                                        "
                                        :href="
                                            !getWhatsappData.linkPage
                                                ? getWhatsappData.registerBtnLink
                                                : ''
                                        "
                                        :target="
                                            !getWhatsappData.linkPage
                                                ? '_blank'
                                                : ''
                                        "
                                        class="align-self-center mt-3"
                                        :small="$breakpoint.xsOnly"
                                        large
                                        color="primary"
                                    >
                                        <span class="font-weight-bold">{{
                                            $t(
                                                "section_promotion.join_now_button"
                                            )
                                        }}</span>
                                    </v-btn>
                                </div>
                            </v-overlay>
                        </template>

                        <template #ribbon>
                            <v-row justify="center" class="ma-0">
                                <Ribbon class="" />
                            </v-row>
                        </template>
                    </profile-header>
                    <!-- <profile-card v-if="$auth.loggedIn" title-size="f16"> </profile-card> -->
                </v-card>
                <v-list
                    v-if="
                        $auth.loggedIn &&
                        environment === 'UAT' &&
                        isStoreEnabled
                    "
                    dense
                    class="drawerLeft store pa-0"
                >
                    <v-row no-gutters>
                        <v-col>
                            <v-list-item
                                :href="openStore()"
                                target="_blank"
                                color="primary border-bottom"
                                class="text-center leftheight border-bottom"
                            >
                                <v-list-item-content class="ml-4">
                                    <div class="d-flex align-items-center">
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/drawer-new/market.webp`"
                                            :src="`${CDN_IMG_URL}/drawer-new/market.webp`"
                                            alt="store"
                                            class="not-white-drawer"
                                            width="20"
                                            height="20"
                                        />
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/drawer-new/market-white.webp`"
                                            :src="`${CDN_IMG_URL}/drawer-new/market-white.webp`"
                                            alt="store"
                                            class="white-drawer"
                                            width="20"
                                            height="20"
                                        />

                                        <div
                                            class="d-flex justify-space-between arrow_width"
                                        >
                                            <span
                                                class="text-capitalize subtitle-1 font-weight-bold pl-3"
                                                :class="
                                                    $vuetify.theme.dark
                                                        ? 'white--text'
                                                        : 'black--text'
                                                "
                                                >Store</span
                                            >
                                            <v-icon size="30" class="pr-1 icon">
                                                mdi-chevron-right</v-icon
                                            >
                                        </div>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-list>
                <v-list dense class="pa-0 drawerLeft">
                    <v-row no-gutters>
                        <v-col
                            v-for="item in drawerLeft"
                            v-show="
                                !item.disable ||
                                (item.disable &&
                                    item.disable !== version.projectCode)
                            "
                            :key="item.title"
                            cols="12"
                        >
                            <v-list-item
                                :to="
                                    item.target !== '_blank' &&
                                    item.link !== '/blog'
                                        ? item.link
                                        : ''
                                "
                                :href="
                                    item.link == '/blog'
                                        ? item.link
                                        : item.target === '_blank'
                                        ? item.link
                                        : ''
                                "
                                :target="item.target"
                                color="primary"
                                class="text-center leftheight border-bottom"
                            >
                                <v-list-item-content class="ml-4">
                                    <div class="d-flex align-items-center">
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/drawer-new/${item.image}.webp`"
                                            :src="`${CDN_IMG_URL}/drawer-new/${item.image}.webp`"
                                            :alt="item.alt"
                                            class="not-white-drawer"
                                            width="20"
                                            height="20"
                                        />
                                        <img
                                            :lazy-src="`${CDN_IMG_URL}/drawer-new/${item.whiteImage}.webp`"
                                            :src="`${CDN_IMG_URL}/drawer-new/${item.whiteImage}.webp`"
                                            :alt="item.alt"
                                            class="white-drawer"
                                            width="20"
                                            height="20"
                                        />
                                        <div
                                            class="d-flex justify-space-between arrow_width"
                                        >
                                            <span
                                                class="text-capitalize subtitle-1 font-weight-bold pl-3"
                                                :class="
                                                    $vuetify.theme.dark
                                                        ? 'white--text'
                                                        : 'black--text'
                                                "
                                                >{{ $t(item.title) }}</span
                                            >
                                            <v-icon size="30" class="pr-1 icon">
                                                mdi-chevron-right</v-icon
                                            >
                                        </div>
                                    </div>

                                    <!-- <v-divider
        v-if="item.title == 'referral program'"
        class="mt-5 black"
      ></v-divider>-->
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-list>
                <v-list dense class="pa-0 drawerHt">
                    <v-row no-gutters>
                        <v-col cols="12" class="ml-4">
                            <switch-locale
                                v-if="$breakpoint.mdAndDown"
                                class="my-4"
                            >
                            </switch-locale>
                            <v-btn
                                v-if="
                                    version &&
                                    version.projectCode &&
                                    version.projectCode !== 'fps'
                                "
                                :href="
                                    domainType === 'FairPlay'
                                        ? '/online-betting-app/'
                                        : '/download-the-app/'
                                "
                                :target="
                                    !getWhatsappData.linkPage ? '_blank' : ''
                                "
                                class="align-self-center my-3 ml-5"
                                :small="$breakpoint.xsOnly"
                                large
                                :color="domainUrl ? 'primary' : 'superBlue'"
                            >
                                <!-- <img
                                    :lazy-src="`${CDN_IMG_URL}/drawer-new/online-betting-app.webp`"
                                    :src="`${CDN_IMG_URL}/drawer-new/online-betting-app.webp`"
                                    alt="store"
                                    class="not-white-drawer"
                                    width="20"
                                    height="20"
                                /> -->

                                <span class="font-weight-bold white--text">
                                    {{ $t("section_download.button") }}</span
                                >
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list>
            </v-navigation-drawer>
        </div>

        <div>
            <SessionTimeEndModal
                :idle-time="idleTime"
                :show-modal-time="showModalTime"
                @SessionTimeOut="SessionOut($event)"
            >
            </SessionTimeEndModal>
        </div>
        <v-dialog
            v-model="feedbackFormDialog"
            scrollable
            max-width="400"
            content-class="feedbackFrom"
        >
            <v-container class="pa-0 ma-0">
                <v-card :class="$breakpoint.xsOnly ? 'pa-4' : 'pa-6'">
                    <v-card-title class="text-h5">Feedback</v-card-title>
                    <!-- <v-row no-gutters> -->
                    <!-- <v-col> -->
                    <v-form ref="feedbackFrom" v-model="valid" lazy-validation>
                        <div class="question-three mb-4">
                            <div>
                                <!-- <div class="mb-4">Feedback</div> -->
                                <v-textarea
                                    v-model="feedbackInput"
                                    outlined
                                    class="rounded-lg"
                                    rows="3"
                                    :rules="rules.feedbackInput"
                                    placeholder="Write a comment or describe a problem."
                                ></v-textarea>
                            </div>
                        </div>
                    </v-form>
                    <!-- </v-col> -->
                    <!-- </v-row> -->
                    <v-card-actions class="pa-4 pt-0">
                        <!-- <v-spacer></v-spacer> -->
                        <v-btn color="primary" @click="submitUserFeedback">
                            Submit
                        </v-btn>
                        <!-- <v-btn color="primary" text to="/"> Back </v-btn> -->
                        <v-btn color="primary" text @click="Closedialog">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-container>
        </v-dialog>
    </div>
</template>

<script>
/*eslint-disable*/
// import { remove } from 'lodash'
import { mapState } from "vuex"
import UserBalance from "@/components/fairplay/UserBalance"
import SessionTimeEndModal from "@/components/SessionTimeEndModal"
import ProfileHeader from "@/components/fairplay/Profile/ProfileHeader"
import ProfileCard from "@/components/fairplay/Profile/ProfileCard"
import Ribbon from "@/components/fairplay/Ribbon"
import socket1 from "@/plugins/newSocket.client"
import service from "@/services/apiService"
import SwitchLocale from "@/components/fairplay/switchLocales"
import encryptor from "~/plugins/encryption"
import constants from "../../../constant"
import eventScript from "../../../services/script"
import drawerWallet from "@/components/fairplay/tripleWallet/drawerWallet"

export default {
    components: {
        UserBalance,
        SessionTimeEndModal,
        ProfileHeader,
        ProfileCard,
        // ProfileMembership,
        // Button,
        Ribbon,
        SwitchLocale,
        drawerWallet
    },
    data() {
        return {
            domainUrl: process.env.THEME_BASIC === "true" ? 1 : 0,
            domainType: process.env.APP_TITLE,
            environment: process.env.fairplayEnvironment,
            CDN_IMG_URL: process.env.CDN_IMG_URL,
            callAvailableNow: false,
            valid: false,
            loading: false,
            isAffiliateUser: false,
            items: [
                // {
                //   title: 'Deposit Now',
                //   icon: 'mdi-cash-plus',
                //   link: '/wallet/deposit',
                //   totalCount: 0,
                //   fpsLink: true,
                //   disable: 'fps'
                // },
                // {
                //   title: 'Withdraw Now',
                //   icon: 'mdi-cash-minus',
                //   link: '/wallet/withdrawal',
                //   totalCount: 0,
                //   fpsLink: true,
                //   disable: 'fps'
                // },
                // {
                //     title: "Referral",
                //     icon: "mdi-account-group",
                //     link: "/referral",
                //     totalCount: 0
                // },
                {
                    title: "Store P&L",
                    icon: "bet_pnl",
                    whiteImage: "bet_pnl_white",
                    link: "/store-profit-loss",
                    totalCount: 0,
                    environment: "UAT"
                },
                {
                    title: "Betting P&L",
                    icon: "bet_pnl",
                    whiteImage: "bet_pnl_white",
                    link: "/profit-loss",
                    totalCount: 0
                },
                {
                    title: "My Transactions",
                    icon: "transactions",
                    whiteImage: "transactions_white",
                    link: "/transactions",
                    totalCount: 0
                },
                {
                    title: "Profile",
                    icon: "profile",
                    whiteImage: "profile_white",
                    link: "/profile",
                    totalCount: 0
                },
                {
                    title: "My Wallet",
                    icon: "wallet",
                    whiteImage: "wallet_white",
                    link: "/wallet",
                    totalCount: 0
                },
                {
                    title: "Reset Password",
                    icon: "reset_password",
                    whiteImage: "reset_password_white",
                    link: "/reset-password",
                    totalCount: 0
                },
                {
                    title: "Change Mobile No",
                    icon: "change_no",
                    whiteImage: "change_no_white",
                    link: "/change-mobileno",
                    totalCount: 0,
                    disable: "fps",
                    environment: "UAT"
                },

                {
                    title: "Open Bets",
                    icon: "open_bets",
                    whiteImage: "open_bets_white",
                    link: "/bets",
                    totalCount: 0
                },
                {
                    title: "Favorites",
                    icon: "favorites",
                    whiteImage: "favorites_white",
                    link: "/favorites",
                    totalCount: 0
                },
                {
                    title: "Notification",
                    icon: "notification",
                    whiteImage: "notification_white",
                    link: "/notifications",
                    totalCount: 0
                },

                // {
                //   title: 'Betting P&L',
                //   icon: 'iconpe-profit-loss',
                //   link: '/transfer-statements',
                //   totalCount: 0,
                //   disable: 'gb'
                // },
                // {
                //   title: 'Transfer Statements',
                //   icon: 'iconpe-transfer-statement',
                //   link: '/transfer-statements',
                //   totalCount: 0
                // },
                // {
                //   title: 'Time Settings',
                //   icon: 'iconpe-time-settings',
                //   link: '/time-settings',
                //   totalCount: 0
                // },

                {
                    title: "Rules & Regulations",
                    icon: "rules",
                    whiteImage: "rules_white",
                    link: "/rules-regulations",
                    totalCount: 0
                },
                {
                    title: "Stake Settings",
                    icon: "settings",
                    whiteImage: "settings_white",
                    link: "/settings",
                    totalCount: 0
                }
            ],
            drawerLeft: [
                // {
                //   title: 'platform offerings',
                //   link: '/platforms'
                // },
                {
                    title: "footer.market",
                    link: "/markets/sportsbook/Cricket",
                    image: "market",
                    whiteImage: "market-white",
                    alt: "Market"
                },
                // {
                //     title: "header.news",
                //     link: process.env.NEWS_PORTAL,
                //     target: "_blank",
                //     image: "news",
                //     whiteImage: "news-white",
                //     alt: "News"
                // },
                {
                    title: "footer.about_us",
                    link: "/about-us",
                    image: "about-us",
                    whiteImage: "about-us-white",
                    alt: "About us"
                },
                {
                    title: "footer.tutorials",
                    link: "/tutorials",
                    image: "help",
                    whiteImage: "help-white",
                    alt: "Tutorials"
                },
                {
                    title: "header.blogs",
                    link: "/blog",
                    image: "terms-and-conditions",
                    whiteImage: "terms-and-conditions-white",
                    alt: "Blogs",
                    disable: "fps"
                },
                {
                    title: "footer.privacy_policy",
                    link: "/privacy-policy",
                    image: "privacy",
                    whiteImage: "privacy-white",
                    alt: "Privacy policy"
                },
                {
                    title: "footer.faq",
                    link: "/faqs",
                    image: "faqs",
                    whiteImage: "faqs-white",
                    alt: "FAQs"
                },
                {
                    title: "section_promotion.header",
                    link: "/promotions",
                    image: "promotions",
                    whiteImage: "promotions-white",
                    alt: "Promotions"
                },
                {
                    title: "footer.loyalty",
                    link: "/loyalty",
                    image: "loyalty",
                    whiteImage: "loyalty-white",
                    alt: "Loyalty"
                },
                {
                    title: "footer.affiliate",
                    link: "/affiliate-partner",
                    image: "affiliate",
                    whiteImage: "affiliate-white",
                    alt: "Affiliate",
                    disable: "fps"
                },
                {
                    title: "side_menu.t_c",
                    link: "/termsandconditions",
                    image: "terms-and-conditions",
                    whiteImage: "terms-and-conditions-white",
                    alt: "Terms&Conditions"
                }
            ],
            popupTimer: 3000,
            logoutTimer: 3600,
            idleInterval: null,
            idleTime: 0,
            showModalTime: false,
            feedback: "",
            feedbackFormDialog: false,
            feedbackInput: "",
            rules: {
                feedbackInput: [
                    (v) => !!v || "Please enter your feedback",
                    (v) =>
                        (v || "").length <= 200 ||
                        "This field exceeds maximum allowed characters"
                ]
            },
            showDrawer1Sec: false,
            showDrawer2Sec: false
        }
    },

    computed: {
        ...mapState({
            totalNoCount: (state) => state.openBets.totalNoCount,
            totalNoCountPremium: (state) => state.openBets.totalNoCountPremium,
            totalNoCountPremiumBookmaker: (state) =>
                state.openBets.totalNoCountPremiumBookmaker,
            userBalanceData: (state) => state.userBalance.userBalanceData,
            configurationData: (state) => state.user.configurationData,
            isStoreEnabled: (state) => state.storePL.isStoreEnabled
        }),
        getWhatsappData() {
            return this.$store.state.user.whatsappData
        },
        version() {
            return this.$store.state.profile.appversion
        },
        walletDetails() {
            return this.$store.state.wallet.data
        },
        getUserCategory() {
            return this.$store.state.wallet.userCategory
        },
        getUserData() {
            return this.$store.state.profile.data
        },
        drawer: {
            get() {
                return this.$store.getters["drawer/value"]
            },
            set(v) {
                return this.$store.commit("drawer/toggle", v)
            }
        },
        drawer1: {
            get() {
                return this.$store.getters["drawer/value1"]
            },
            set(v) {
                return this.$store.commit("drawer/toggle1", v)
            }
        },
        name() {
            return this.$store.state.profile.data.name
        },
        user() {
            return this.$store.state.profile.data
        },
        userPendingBonusSum() {
            return this.$store.state.userBalance.userPendingBonusSum
        },
        zivoWebcallData() {
            return this.$store.state.wallet.zivoWebcallData
        },
        depositWhatsappLink() {
            return this.$store.state.profile.data.whatsAppLink
            // return sessionStorage.getItem("depositWhatsapp")
        }
    },
    watch: {
        getUserData() {
            this.checkAffiliateUser()
        },
        user() {
            if (this.$auth && this.$auth.loggedIn) {
                this.$store.dispatch("user/getWhatAppDepositSetting")
            }
        }
    },
    created() {
        if (this.$auth.loggedIn) {
            this.activeGames()
            this.$store.dispatch("wallet/getTrunOverDetailsForWallet")
            if (this.$route.params.subCategory !== "UOFGame") {
                this.$store.dispatch("openBets/getMyCurrentBetStatus", false)
            }
            this.$store.dispatch("openBets/getMyCurrentPremiumRawBet", false)
            this.$store.dispatch(
                "openBets/getMyCurrentBetStatusBookmakerMarket",
                false
            )
        }
        this.startTimer()
    },
    mounted() {
        if (this.$auth && this.$auth.loggedIn) {
            this.clickEvent()
        }
        if (process.client) {
            document.addEventListener("mousemove", this.mousemoveEvent)
            document.addEventListener("click", this.clickEvent)
            document.addEventListener("keypress", this.keypressEvent)
        }
        if (this.$auth && this.$auth.loggedIn) {
            const userDetail = JSON.parse(
                encryptor.decrypt(sessionStorage.getItem("getOneUser"))
            )
            if (userDetail && userDetail.data && userDetail.data.userData) {
                const userId = userDetail.data.userData._id
                socket1.on(`userBonus-${userId}`, (data) => {
                    try {
                        this.$store.dispatch("userBalance/getCurrentBalance")
                    } catch (err) {
                        console.log("ERROR:", err)
                    }
                })
            }
            this.webCallSettings()
            // this.$store.dispatch("userBalance/getPendingBonusSum")
            // this.$store.dispatch("storePL/checkStoreEnabled", null, {
            //     root: true
            // })
        }
        if (!constants.loadComponentsOnScroll) {
            this.showDrawer1Sec = true
            this.showDrawer2Sec = true
        }
        if (
            process.env.APP_TITLE === "SuperWin" &&
            this.drawerLeft &&
            this.drawerLeft.length
        ) {
            this.drawerLeft = this.drawerLeft.filter((item) => {
                return (
                    item.title !== "footer.market" &&
                    item.title !== "footer.tutorials" &&
                    item.title !== "header.news"
                )
            })
        }
        if (
            process.env.APP_TITLE === "FairPlay" &&
            this.drawerLeft &&
            this.drawerLeft.length
        ) {
            this.drawerLeft = this.drawerLeft.filter((item) => {
                return item.title !== "footer.tutorials"
            })
        }
    },
    methods: {
        async checkAffiliateUser() {
            this.isAffiliateUser = await this.$store.dispatch(
                "wallet/checkAffiliateProcess"
            )
        },
        goToWhatsapp() {
            // window.open(`https://api.whatsapp.com/send?phone=${constants.CONTACT_NO}`)
            // window.open(
            //   `https://api.whatsapp.com/send?phone=https://web.whatsapp.com/send?phone=${constants.WHATSAPP_NO}`
            // )
            if (
                this.getWhatsappData &&
                this.getWhatsappData.isWhatsAppNo &&
                this.getWhatsappData.whatsAppLink
            ) {
                // window.open(
                //   `https://api.whatsapp.com/send?phone=${this.getWhatsappData.number}`
                // )
                // window.open(this.getWhatsappData.whatsAppLink)
                return this.getWhatsappData.whatsAppLink
            }
        },
        goToWhatsappNew() {
            // window.open(`https://api.whatsapp.com/send?phone=${constants.CONTACT_NO}`)
            // window.open(
            //   `https://api.whatsapp.com/send?phone=https://web.whatsapp.com/send?phone=${constants.WHATSAPP_NO}`
            // )
            if (
                this.getWhatsappData &&
                this.getWhatsappData.number &&
                this.getWhatsappData.whatsAppLink &&
                process.client
            ) {
                // window.open(
                //   `https://api.whatsapp.com/send?phone=${this.getWhatsappData.number}`
                // )
                window.open(this.getWhatsappData.whatsAppLink)
            }
        },
        goToTelgram() {
            if (
                this.getWhatsappData &&
                this.getWhatsappData.isTelegramOn &&
                this.getWhatsappData.telegramLink &&
                process.client
            ) {
                window.open(this.getWhatsappData.telegramLink)
            }
        },
        showSnackbar({ content, color }) {
            this.$store.commit("snackbar/open", {
                text: content,
                color
            })
        },
        openFeedback() {
            this.feedbackFormDialog = true
            this.drawer = false
        },
        closeFeedbackFormDialog() {
            // this.$refs.surveyForm.resetValidation()
            // this.$refs.surveyForm.reset()
            this.feedbackFormDialog = false
        },
        async submitUserFeedback() {
            this.$refs.feedbackFrom.validate()

            if (!this.$refs.feedbackFrom.validate()) {
                return
            }
            // this.surveyFormDialog = false
            const response = await this.$store.dispatch(
                "feedbackForm/userFeedback",
                {
                    feedback: this.feedbackInput
                }
            )
            if (response && response.status && response.status === 200) {
                this.showSnackbar({
                    content: response.data.data
                        ? response.data.data
                        : "Feedback Updated Successfully",
                    color: "success"
                })
                this.$refs.feedbackFrom.reset()
                this.$refs.feedbackFrom.resetValidation()
                this.feedbackFormDialog = false
            } else {
                if (
                    response &&
                    response.data &&
                    response.data.error &&
                    response.data.error.feedback
                ) {
                    this.showSnackbar({
                        content: response.data.error.feedback,
                        color: "error"
                    })
                } else {
                    this.showSnackbar({
                        content: response.data.error,
                        color: "error"
                    })
                }
                this.$store.commit("feedbackFrom/SET_ERROR", null)
                this.$refs.feedbackFrom.reset()
                this.$refs.feedbackFrom.resetValidation()
                this.feedbackFormDialog = false
            }
        },
        Closedialog() {
            this.$refs.feedbackFrom.resetValidation()
            this.$refs.feedbackFrom.reset()
            this.feedbackFormDialog = false
        },
        openChat() {
            try {
                if (process.client) {
                    const classname = document.getElementById(
                        "mobile-chat-container"
                    )
                    if (classname && classname.classList) {
                        classname.classList.add("mobile-chat-container")
                        classname.classList.remove("d-none")
                    }
                    classname.click()

                    // const classChat = document.getElementsByClassName(
                    //     "intercom-lightweight-app"
                    // )[0]
                    // if (classChat && classChat.classList) {
                    //     classChat.classList.remove("d-none")
                    // }
                    // const classId =
                    //     document.getElementById("intercom-container")
                    // if (classId && classId.classList) {
                    //     classId.classList.remove("d-none")
                    // }
                    // classChat.click()
                    // Intercom("show")
                    // const element = document.getElementById("fc_frame")
                    // if (element && element.style) {
                    //     element.style.visibility = "visible"
                    // }
                    // element.classList.remove("d-none")
                    // window.fcWidget.open()
                }
            } catch (error) {}
        },
        clickEvent() {
            if (!this.showModalTime) {
                this.idleTime = 0
            }
            // Load drawer1 starts
            var loadDrawer1 = this.$refs["drawer1"]
            if (loadDrawer1) {
                this.showDrawer1Sec = eventScript.onscrollComponentLoad(
                    loadDrawer1,
                    this.showDrawer1Sec,
                    this.$breakpoint.xsOnly
                )
            }
            // Load drawer1 ends
            // Load drawer2 Sec starts
            var loadDrawer2 = this.$refs["drawer2"]
            if (loadDrawer2) {
                this.showDrawer2Sec = eventScript.onscrollComponentLoad(
                    loadDrawer2,
                    this.showDrawer2Sec,
                    this.$breakpoint.xsOnly
                )
            }
            // Load drawer2 Sec ends
        },
        mousemoveEvent() {
            if (!this.showModalTime) {
                this.idleTime = 0
            }
        },
        keypressEvent() {
            if (!this.showModalTime) {
                this.idleTime = 0
            }
        },
        startTimer() {
            clearInterval(this.idleInterval)
            this.idleTime = 0
            if (this.$auth.loggedIn) {
                this.idleInterval = setInterval(this.timerIncrement, 1000)
            }
        },

        timerIncrement() {
            this.idleTime = this.idleTime + 1
            // popup function
            if (this.idleTime === this.popupTimer) {
                this.showModalTime = true
            }

            if (this.idleTime >= this.logoutTimer) {
                clearInterval(this.idleInterval)
                this.$store.dispatch("user/logout")
                this.idleTime = 0
            }
        },

        SessionOut(value) {
            this.showModalTime = value
            this.idleTime = 0
        },

        activeGames() {
            if (!this.$auth.user.sportsbook) {
                this.items = this.items.filter((game) => {
                    if (
                        game.title === "Favorites" ||
                        game.title === "Settings"
                    ) {
                        return !game
                    }
                    return game
                })
            }
        },
        getCategoryWiseBackgroundImage() {
            if (this.getUserCategory && this.getUserCategory.categoryName) {
                if (this.getUserCategory.categoryName === "Blue") {
                    return `${process.env.CDN_IMG_URL}/loyalty/left-blue.webp`
                } else if (this.getUserCategory.categoryName === "Silver") {
                    return `${process.env.CDN_IMG_URL}/loyalty/left-silver.webp`
                } else if (this.getUserCategory.categoryName === "Gold") {
                    return `${process.env.CDN_IMG_URL}/loyalty/left-gold.webp`
                } else if (this.getUserCategory.categoryName === "Platinum") {
                    return `${process.env.CDN_IMG_URL}/loyalty/left-platinum.webp`
                } else {
                    return `${process.env.CDN_IMG_URL}/loyalty/left-blue.webp`
                }
            } else {
                return `${process.env.CDN_IMG_URL}/loyalty/left-blue.webp`
            }
        },
        onRequestcall() {
            if (this.$cookies.isKey("callCookies")) {
                this.showSnackbar({
                    content:
                        "Request already in progress, please try after 5 mins",
                    color: "error"
                })
            } else {
                this.getCall()
            }
        },
        async getCall() {
            try {
                const datasent = {
                    number: this.user.mobileNo.includes("+")
                        ? +this.user.mobileNo.substring(1)
                        : +this.user.mobileNo
                }
                const calldone = await service.apiCallWithHeader(
                    "/v2/getWebCall",
                    datasent
                )
                if (calldone && calldone.data && calldone.status === 200) {
                    this.showSnackbar({
                        content:
                            "Our customer representative will get back to you shortly",
                        color: "success"
                    })
                } else if (calldone && calldone.data && calldone.data.error) {
                    this.showSnackbar({
                        content: calldone.data.error.number,
                        color: "error"
                    })
                } else {
                    this.showSnackbar({
                        content: "Something went wrong",
                        color: "error"
                    })
                }
                this.$cookies.set("callCookies", "callCookies", "5min")
                this.drawer = false
            } catch (e) {
                this.showSnackbar({
                    content: e,
                    color: "error"
                })
            }
        },
        async webCallSettings() {
            try {
                const now = this.$moment().utc().format("HH:mm")
                await this.$store.dispatch("wallet/getZivoWebCallSetting")
                if (this.zivoWebcallData) {
                    const showCallFeature = this.zivoWebcallData.zivoWebcall
                    const from = this.zivoWebcallData.zivoWebcallStartTime
                    const to = this.zivoWebcallData.zivoWebcallEndTime
                    if (now >= from && now <= to && showCallFeature === true) {
                        this.callAvailableNow = true
                    } else {
                        this.callAvailableNow = false
                    }
                }
            } catch (err) {
                console.log("Error checking call availablity")
            }
        },
        openStore() {
            if (this.$auth.loggedIn && localStorage.getItem("accessToken")) {
                return `${
                    process.env.FAIRPLAY_STORE_URL
                }/?u=${localStorage.getItem("accessToken")}`
            }
        }
    }

    // destroyed() {
    //   clearInterval(this.idleInterval)
    // }
}
</script>

<style lang="scss" scoped>
.drawer-main {
    .left_border {
        border-left: 0.5px groove var(--v-orangemid-base);
    }
    .awaiting_bonus {
        background-color: black !important;
        color: var(--v-orangemid-base);
        border: 1px solid var(--v-orangemid-base);
        display: flex;
        justify-content: space-between;
        border-radius: 16px;
        width: 100%;
    }
    .divider-color {
        background: grey !important;
    }
    .v-list-item--active {
        background: var(--v-orangemid-base);
        border-bottom: 1px solid var(--v-orangemid-base);
        .not-white-drawer {
            display: none;
        }
        .white-drawer {
            display: block;
        }
    }
    .v-list-item {
        padding: 0px;
    }
    .v-list-item {
        background: none;
    }

    .not-white-drawer {
        display: block;
    }
    .white-drawer {
        display: none;
    }
    .refer {
        color: $white;
        text-decoration: none;
    }
    .whatsapp-text {
        border: 1px solid $white !important;
        box-shadow: none;
        border-radius: 16px;
        width: 100%;
        &:hover {
            background-color: #4caf50 !important;
            font-size: 12px;
        }
    }
    .telegram-text {
        border: 1px solid $white !important;
        box-shadow: none;
        border-radius: 16px;
        width: 100%;
        &:hover {
            background-color: #049be5 !important;
            font-size: 12px;
        }
    }
    .whatsapp-style .v-btn__content {
        display: grid;
        flex: none;
    }
    .mobileLang {
        float: left;
        margin-bottom: 5px;
    }
    .drawerHt {
        padding-bottom: 120px !important;
    }
    .store {
        .icon {
            color: grey;
        }
        .col:last-child {
            background: transparent !important;
            .v-list-item {
                border-bottom: 1px solid grey !important;
            }
        }

        @media (hover: hover) and (pointer: fine) {
            .col:last-child:hover {
                background: var(--v-orangemid-base) !important;
                .not-white-drawer {
                    display: none;
                }
                .white-drawer {
                    display: block;
                }
            }
        }
    }
    .drawerLeft {
        .icon {
            color: grey;
        }
        .v-list-item {
            border-bottom: 1px solid gray;
        }
        .v-list-item--active {
            background: var(--v-orangemid-base);
            border-bottom: 1px solid gray;
            .not-white-drawer {
                display: none;
            }
            .white-drawer {
                display: block;
            }
        }
        .leftheight {
            height: 50px;
            // margin-left: 10px;
        }
        .v-list-item:hover {
            border-bottom: 1px solid gray;
        }

        .col:hover {
            // border-bottom: 1px solid rgb(231, 11, 11);
        }

        @media (hover: hover) and (pointer: fine) {
            .col:hover {
                background: var(--v-orangemid-base);
                .not-white-drawer {
                    display: none;
                }
                .white-drawer {
                    display: block;
                }
                .icon {
                    color: white;
                }
            }
        }

        .col:last-child a {
            border-bottom: none;
            // background: var(--v-bottomChildColor-base);
        }
        .col:last-child a:hover {
            border-bottom: none !important;
            // background: var(--v-bottomChildColor-base);
            .v-list-item {
                border-bottom: none !important;
            }
            .icon {
                color: white;
            }
        }
    }
    .left-profile {
        align-items: center;
        justify-content: center;
        display: flex;
    }
    .h100 {
        height: 100px;
    }
    .h150 {
        height: 150px;
    }

    .bg-image-css {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .padding-bottom {
        padding-bottom: 100px !important;
    }
    .green_bg {
        background: var(--v-bottomChildColor-base);
    }
}
.v-navigation-drawer {
    z-index: 1000;
}
.padding-bottom {
    padding-bottom: 100px !important;
}
.deposit_btn {
    border-radius: 16px;
}
.referal_btn {
    width: 100%;
}
.list_border {
    border-bottom: 1px solid grey;
}
.list_border_top {
    border-top: 1px solid grey;
}
.right_drawer {
    .v-list-item--active {
        background: var(--v-orangemid-base);
        border-bottom: 1px solid gray;
        .not-white-drawer {
            display: none;
        }
        .white-drawer {
            display: block;
        }
        .list_border {
            border-bottom: none;
        }
        .count-badge {
            background-color: $white !important;
            border-color: $white !important;
            color: var(--v-orangemid-base);
        }
    }
    .v-list-item--active::before {
        opacity: 0;
    }
    @media (hover: hover) and (pointer: fine) {
        .col:hover {
            background: var(--v-orangemid-base);
            border-bottom: none;
            .not-white-drawer {
                display: none;
            }
            .white-drawer {
                display: block;
            }
            .list_border {
                border-bottom: 1px solid gray;
            }
            .count-badge {
                background-color: $white !important;
                border-color: $white !important;
                color: var(--v-normalThemeColor-base);
            }
        }
    }
}
.arrow_width {
    width: 100%;
}
</style>
